import { useCallback, useEffect, useState } from 'react';
import { adminLogin, adminLogout, adminSession } from '../services/adminApi';

export const useAdminAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingSession, setIsCheckingSession] = useState(true);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    adminSession()
      .then((data) => setIsAuthenticated(Boolean(data?.authenticated)))
      .catch(() => setIsAuthenticated(false))
      .finally(() => setIsCheckingSession(false));
  }, []);

  const login = useCallback(async (password) => {
    if (!password) {
      setAuthError('Merci de renseigner le mot de passe.');
      return;
    }
    setIsAuthenticating(true);
    setAuthError(null);
    try {
      await adminLogin(password);
      setIsAuthenticated(true);
    } catch (error) {
      setAuthError(error.message || 'Mot de passe incorrect.');
      setIsAuthenticated(false);
    } finally {
      setIsAuthenticating(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminLogout();
    } finally {
      setIsAuthenticated(false);
    }
  }, []);

  return { isAuthenticated, isCheckingSession, isAuthenticating, authError, login, logout };
};
